export default "__VITE_ASSET__0e6615d6__"